import { Component, OnInit } from '@angular/core';
import { CourseService } from 'src/app/services/course.service';
import { Course } from 'src/app/models/course';
import { ActivatedRoute } from '@angular/router';
import { NotificationService } from 'src/app/services/notification.service';
import { PracticeService } from 'src/app/services/practice.service';
import { Practice } from 'src/app/models/practice';
import { Quiz } from 'src/app/models/quiz';
import { QuizQuestionAnswer } from 'src/app/models/quizQuestionAnswer';
import { QuizService } from 'src/app/services/quiz.service';
import { QuizQuestion } from 'src/app/models/quizQuestion';

@Component({
  selector: 'app-practice-content-quiz',
  templateUrl: './practice-content-quiz.component.html',
  styleUrls: ['./practice-content-quiz.component.scss']
})
export class PracticeContentQuizComponent implements OnInit {
  public practiceId;
  public practice;
  public loadedPractice:boolean=false;
  public loadedCourse:boolean = false;
  public course: Course;
  private courseId;
  public quiz: Quiz;
  public quizId;
  public quizLoaded:boolean=false;

  constructor(
    private _practice: PracticeService,
    private _quiz: QuizService,
    private courseService: CourseService,
    private _notify: NotificationService,
    private route: ActivatedRoute
  ) {
    this.quizId=this.route.snapshot.paramMap.get("quiz_id");
    this.practiceId = this.route.snapshot.paramMap.get("practiceId");
    this.courseId = this.route.snapshot.paramMap.get("courseId");
  }

  public addQuestion(){
    this._quiz.addQuestion(this.quiz.id).subscribe(
      (res:QuizQuestion) => {
        this.quiz.questions.push(new QuizQuestion(res));
      }
    );
  }

  public deleteQuestion(
    questionId:number,
    questionIndex:number
  ){
    if(!confirm('Confirm you want to delete this question.')) return;
    this._quiz.deleteQuestion(questionId).subscribe(
      res => {
        this.quiz.questions.splice(questionIndex, 1);
        this._notify.showMessage('Question deleted.', 'OK');
      }
    );
  }

  public addAnswer(
    questionId:number,
    questionIndex:number
  ) {
    this._quiz.addAnswer(this.quiz.id, questionId).subscribe(
      res => {
        this.quiz.questions[questionIndex].answers.push(new QuizQuestionAnswer(res));
      }
    );
  }

  public deleteAnswer(
    questionIndex:number,
    answerIndex:number,
    answerId:number
  ) {
    this._quiz.deleteAnswer(answerId).subscribe(res => {
      this.quiz.questions[questionIndex].answers.splice(answerIndex,1);
    });
  }

  public saveQuiz(){
    this._quiz.saveQuiz(this.quiz).subscribe(res => {
      this._notify.showMessage('Quiz updated', 'OK');
    });
  }

  public getPractice(){
    this._practice.getPractice(this.practiceId).subscribe(
      res=>{
        this.practice=new Practice(res);
        this.loadedPractice=true;
      }
    );
  }

  ngOnInit() {
    this.getPractice();
    this.courseService.getCourse(this.courseId).subscribe(course=>{
      this.course=course;
      this.loadedCourse = true;
    });
    this.courseService.getQuiz(this.quizId).subscribe(
      res => {
        this.quiz=res;
        this.quizLoaded=true;
      }
    );
  }

}
